import { Injectable } from '@angular/core';
import { Product } from '../shared/product';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { UserDetailsService } from './user-details.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root',
})
export class ProductSatusService {
  apiURL = environment.oneLogApi;
  constructor(
    private http: HttpClient,
    private userDetails: UserDetailsService,
    private headerService: HeaderService
  ) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  // HttpClient API get() method => Fetch Product list
  getStatusList(): Observable<Product> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http
      .get<Product>(this.apiURL + '/product_status_list', requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
